export const UPDATE_CONFIGURACOES = "UPDATE_CONFIGURACOES";

